import type VoterDto from '../dtos/voter.dto'
import type VotersDto from '../dtos/voters.dto'
import type Voter from '../models/voter.model'
import type Voters from '../models/voters.model'
import type ConstituencyVotersModel from '@/modules/voter/models/constituency-voters.model'
import type ConstituencyVotersDto from '@/modules/voter/dtos/constituency-voters.dto'
import type ConstituencyVoterDto from '@/modules/voter/dtos/constituency-voter.dto'
import type ConstituencyVoterModel from '@/modules/voter/models/constituency-voter.model'

export function mapVoterFromVoterDTO(dto?: VoterDto | null): Voter | null {
  return !dto
    ? null
    : ({
        year: dto.year,
        voters: dto.voters.map(mapVotersDtoFromVotersDtoDTO)
      } as Voter)
}

export function mapConstituencyVoterFromConstituencyVoterDTO(dto?: ConstituencyVoterDto | null): ConstituencyVoterModel | null {
  return !dto
    ? null
    : ({
        year: dto.year,
        voters: dto.voters.map(mapConstituencyVotersDtoFromConstituencyVotersDtoDTO)
      } as ConstituencyVoterModel)
}

export function mapVotersDtoFromVotersDtoDTO(dto?: VotersDto | null): Voters | null {
  return !dto
    ? null
    : ({
        region: dto.region,
        constituency: dto.constituency,
        stationCode: dto.station_code ?? '',
        stationName: dto.station_name ?? '',
        totalVoters: dto.total_voters,
        totalVotersMale: dto.total_voters_male,
        totalVotersFemale: dto.total_voters_female,
        voters: dto.voters,
        votersMale: dto.voters_male,
        votersFemale: dto.voters_female
      } as Voters)
}

export function mapConstituencyVotersDtoFromConstituencyVotersDtoDTO(
  dto?: ConstituencyVotersDto | null
): ConstituencyVotersModel | null {
  return !dto
    ? null
    : ({
        region: dto.region,
        constituency: dto.constituency,
        stationCode: dto.station_code ?? '',
        stationName: dto.station_name ?? '',
        totalVoters: dto.total_voters,
        totalVotersMale: dto.total_voters_male,
        totalVotersFemale: dto.total_voters_female,
        voters: dto.voters,
        votersMale: dto.voters_male,
        votersFemale: dto.voters_female
      } as ConstituencyVotersModel)
}
